<div class="header col gap-16">
    <img src="/images/default-agent.png" alt="Default Johnny Image" />
    <div class="col gap-4" i18n>
        <div class="uppercase-label">Hello there,I’m Johnny!</div>
        <h2>Congratulations, little <br />Inno-Hero 🎉</h2>
    </div>
</div>
<div class="col gap-16 questions">
    <img src="/images/jhonny-gratulations.png" alt="" class="w100" />
    <div class="tiny">What's next</div>
    @for(e of data; track e;){

    <div class="row gap-8 align-start">
        <rr-icon name="arrow-right" class="w24" color="nutral"></rr-icon>
        <div class="col">
            <h4 class="strong">{{ e.title }}</h4>
            <div class="">{{ e.description }}</div>
        </div>
    </div>
    }
</div>
<div class="btnarea w100 justify-end row" i18n>
    <rr-btn type="Primary" iconEnd="arrow-right" (click)="close()"
        >Proceed</rr-btn
    >
</div>
